/**
 * Clones the given value.
 */
export function clone<T>(value: T): T
{
	if (value === undefined)
	{
		return undefined as unknown as T;
	}
	else if (Number.isNaN(value))
	{
		return NaN as unknown as T;
	}
	else if (typeof structuredClone === 'function')
	{
		// Available in Node >= 18.
		return structuredClone(value);
	}
	else
	{
		return JSON.parse(JSON.stringify(value));
	}
}

/**
 * Generates a random positive integer.
 */
export function generateRandomNumber(): number
{
	return Math.round(Math.random() * 10000000);
}

export function getSubSet(arr1: any[], arr2: any[]) {
	var set1 = new Set(arr1);
	var set2 = new Set(arr2);
	var subset = [];

	for (let item of set1) {
		if (!set2.has(item)) {
			subset.push(item);
		}
	}
	return subset;
}

    /**
     * Creates and loads an image element by url.
     * @param  {String} url
     * @return {Promise} promise that resolves to an image element or
     *                   fails to an Error.
     */
	 function request_image(url:string) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() { resolve(img); };
            img.onerror = function() { reject(url); };
            img.src = url + '?random-no-cache=' + Math.floor((1 + Math.random()) * 0x10000).toString(16);
        });
    }

    /**
     * Pings a url.
     * @param  {String} url
     * @param  {Number} multiplier - optional, factor to adjust the ping by.  0.3 works well for HTTP servers.
     * @return {Promise} promise that resolves to a ping (ms, float).
     */
    export function ping(url:string, multiplier:number) {
        return new Promise(function(resolve, reject) {
            var start = (new Date()).getTime();
            var response = function() { 
                var delta = ((new Date()).getTime() - start);
                delta *= (multiplier || 1);
                resolve(delta); 
            };
            request_image(url).then(response).catch(response);
            
            // Set a timeout for max-pings, 5s.
            setTimeout(function() { reject(Error('Timeout')); }, 5000);
        });
    }

//返回当前用户所使用的是什么浏览器
const userAgent = navigator.userAgent.toLowerCase()
//移动端
const isMobile = /mobile/i.test(userAgent)
//android
const isAndroid = /android/i.test(userAgent)
//IOS
const isIOS = /iphone|ipad|ipod/i.test(userAgent)
//wx
const isWX = /MicroMessenger/i.test(userAgent)
//记得输出哦
export {
  isMobile,
  isAndroid,
  isIOS,
  isWX
}
